import { Film, Video, UserCheck, UserPlus } from 'lucide-react';

/**
 * Иконка по машинному ключу стадии — чисто косметика поверх авто-списка
 * стадий (Layout.jsx строит пункты меню из GET /stages?talent_type=X, а не
 * хардкодом): для известных сегодня стадий подобрана своя иконка, а для
 * любой стадии, которой здесь нет (новая, ещё не заведена в карту),
 * используется Film — тот же принцип "работает без правок кода", что и у
 * самого списка стадий, просто с менее однообразной картинкой для тех,
 * что уже знаем.
 *
 * Общая для всех разделов навигации (candidate сегодня, employee/другие
 * типы — когда там тоже появится авто-список стадий), поэтому вынесена
 * сюда, а не оставлена локальной константой в Layout.jsx.
 */
export const STAGE_ICONS = {
  video: Film,
  interview: Video,
  pre_onboarding: UserCheck,
  onboarding: UserPlus,
};

export const DEFAULT_STAGE_ICON = Film;

/**
 * @param {string} stageKey
 * @returns {import('react').ComponentType} lucide-react icon component
 */
export const getStageIcon = (stageKey) => STAGE_ICONS[stageKey] || DEFAULT_STAGE_ICON;
